import { createAction, props } from '@ngrx/store';
import { OrderType } from 'src/app/pages/dispatch/models/order.model';

export const loadOrderTypes = createAction('[Order Types] Load', props<{ groupTypeIndicatorId: number | null }>());

export const loadOrderTypesSuccess = createAction('[Order Types] Load Success', props<{ response: OrderType[] }>());

export const loadOrderTypesSuccessByKey = createAction(
  '[Order Types] Load Success By Key',
  props<{ key: string; response: OrderType[] }>(),
);

export const loadOrderTypesFailure = createAction('[Order Types] Load Failure', props<{ error: any }>());
